module.exports = __webpack_public_path__ + "img/start.1489ea4e.svg";